import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Rekap Free Kembalian ", -1)
const _hoisted_3 = { class: "card-body px-0 py-0" }
const _hoisted_4 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "No Nota"),
    /*#__PURE__*/_createElementVNode("th", null, "Jam Transaksi"),
    /*#__PURE__*/_createElementVNode("th", null, "Nominal Bayar"),
    /*#__PURE__*/_createElementVNode("th", null, "Free Kembalian")
  ])
], -1)
const _hoisted_7 = { class: "bg-light" }
const _hoisted_8 = {
  colspan: "7",
  class: "text-center text-muted"
}
const _hoisted_9 = {
  key: 0,
  class: "card-body"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Data masih kosong", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freeReturn, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.code_nota), 1),
                    _createElementVNode("td", null, _toDisplayString(item.jam_bayar), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nominal_total_bayar), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.subTotal(item.nominal_free_kembalian, item.nominal_free_kembalian_void)), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tfoot", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, " TOTAL: " + _toDisplayString(_ctx.total), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
      : _createCommentVNode("", true)
  ]))
}